import { render } from "./Sunshine.vue?vue&type=template&id=21535e3d"
import script from "./Sunshine.vue?vue&type=script&lang=js"
export * from "./Sunshine.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__